export const matchingtitleFromPath = {
  oper: 'OPER',
  'map-view': 'LON/Lat maps',
  range: 'TIME SERIES',
  'tz-view': 'DEPTH vs TIME',
  'in-situ': 'Vertical Profile',
  omi: 'Copernicus Marine Ocean Monitoring indicators',
};

export default {
  matchingtitleFromPath,
};
